module.exports = __webpack_public_path__ + "img/icx.07c6d678.svg";